import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ListCustomersComponent } from './components/list-customers/list-customers.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddCustomersComponent } from './components/add-customers/add-customers.component';
import { RecapLocationComponent } from './components/recap-location/recap-location.component';
import { InsertingCatalogsComponent } from './components/inserting-catalogs/inserting-catalogs.component';
import { AddContactsComponent } from './components/add-contacts/add-contacts.component';
import { EditAddressComponent } from './components/edit-address/edit-address.component';
import { EditBasicCutomInfoComponent } from './components/edit-basic-cutom-info/edit-basic-cutom-info.component';
import { EditCustomInvoicComponent } from './components/edit-custom-invoic/edit-custom-invoic.component';
import { EditFilesComponent } from './components/edit-files/edit-files.component';
import { CustomersFiltersComponent } from './components/customers-filters/customers-filters.component';
import { InviteConfirmationComponent } from './components/invite-confirmation/invite-confirmation.component';
import { UiModule } from 'src/app/ui/ui.module';
import { ObjectCustomFieldsViewComponent } from 'src/app/shared/components/object-custom-fields-view/object-custom-fields-view.component';
import { CustomerCustomFieldsComponent } from './components/customer-custom-fields/customer-custom-fields.component';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';
import { AddLocationsComponent } from './components/add-locations/add-locations.component';
import { CustomerInformationsComponent } from './components/recap-location/customer-informations/customer-informations.component';
import { LocationMapComponent } from './components/recap-location/location-map/location-map.component';
import { LocationOrdersTabComponent } from './components/recap-location/location-orders-tab/location-orders-tab.component';




@NgModule({
  declarations: [
    ListCustomersComponent,
    AddCustomersComponent,
    RecapLocationComponent,
    InsertingCatalogsComponent,
    AddContactsComponent,
    AddLocationsComponent,
    CustomerInformationsComponent,
    EditAddressComponent,
    EditBasicCutomInfoComponent,
    EditCustomInvoicComponent,
    EditFilesComponent,
    CustomersFiltersComponent,
    InviteConfirmationComponent,
    CustomerCustomFieldsComponent,
    LocationMapComponent,
    LocationOrdersTabComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    MatProgressSpinnerModule,
    ObjectCustomFieldsViewComponent,
    ObjectCustomFieldsFormComponent,
  ],
  exports: [
    InsertingCatalogsComponent
  ]
})
export class CustomersModule { }
